import { Component, HostListener, input, output, ChangeDetectionStrategy } from '@angular/core';
import { DvButtonComponent } from '@devinco/ui/dds';

@Component({
  selector: 'app-sidesheet',
  imports: [DvButtonComponent],
  templateUrl: './sidesheet.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './sidesheet.component.scss',
})
export class SidesheetComponent {
  open = input<boolean>(false);
  closed = output<void>();

  @HostListener('document:keydown.escape', ['$event'])
  onEscKey(event: Event) {
    event.preventDefault();
    this.onClose();
  }

  onClose() {
    this.closed.emit();
  }
}
